/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { ButtonList, CosmosButtonProps } from "@components/elements";
import { CosmosIconButtonFragment, CosmosButtonFragment } from "@cosmos/hygraph-schema";

interface Props {
	className?: string;
	buttons?: (CosmosButtonFragment | CosmosIconButtonFragment)[] | null;
	seatCount?: number;
	seatPurchaseUrl?: string;
}

export const LicenseCardButtons = ({
	className,
	buttons = [],
	seatCount,
	seatPurchaseUrl,
}: Props): React.JSX.Element | null => {
	if (!buttons) return null;
	const seatPurchaseUrlWithSeatCount = `${seatPurchaseUrl}${seatCount}`;
	const cosmosButtons = buttons.map((button, i): CosmosButtonProps => {
		return {
			...button,
			size: "lg",
			href: !!seatCount && i === 0 ? seatPurchaseUrlWithSeatCount : button.href,
			analytics: {
				eventCategory: "button",
				interactionType: "click",
				eventAction: "navigation",
				eventLabel: button.name || button.label || "",
				eventValue: {
					component: "LicenseCard",
				},
			},
		};
	});

	if (!cosmosButtons) return null;

	return <ButtonList className={className} buttons={cosmosButtons} />;
};
